import { useState, useContext, useEffect } from "react"
import { login } from "services/login.service"
import { useNotifications } from "@mantine/notifications"
import { Loader } from "@mantine/core"
import { Icon } from "@material-tailwind/react"
import { getAll } from "services/api.service"
import AuthContext from "context/AuthContext"
import logo from "assets/img/logo.jpg"
import useFetchAndLoad from "hooks/useFetchAndLoad.ts"
import WorksitesContext from "context/WorksitesContext"

const Login = () => {
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const [error, setError] = useState("")
  const { loading, callEndpoint } = useFetchAndLoad()
  const notifications = useNotifications()

  const authContext = useContext(AuthContext)
  const worksitesContext = useContext(WorksitesContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    await callEndpoint(login({ email, password }))
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (response.data.data.access_level !== 1) {
            notifications.showNotification({
              color: "yellow",
              title: "No autorizado",
              message: "Este usuario no está autorizado para acceder al panel.",
              icon: <Icon name={"close"} />,
            })
            return
          }
          setUserToken(response)
          setWorksites()
        }
      })
      .catch((error) => {
        showErrorNotification()
      })
  }

  const setUserToken = (response) => {
    authContext.login(response.data.data.access_token)

    if (localStorage.getItem("token")) {
      showSuccessNotification()
    }
  }

  const setWorksites = async () => {
    await callEndpoint(getAll("/worksites"))
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          worksitesContext.updateWorksites(response.data.data)
        }
      })
      .catch((error) => {
        notifications.showNotification({
          color: "red",
          title: "Error",
          message: "Error al obtener las obras",
        })
      })
  }

  const showSuccessNotification = () => {
    notifications.showNotification({
      color: "green",
      title: "Bienvenido",
      message: "Acceso exitoso",
      icon: <Icon name={"check"} />,
    })
  }

  const showErrorNotification = () => {
    notifications.showNotification({
      color: "red",
      title: "Error",
      message: "Ha ocurrido un error, por favor intente nuevamente.",
      icon: <Icon name={"close"} />,
    })
  }

  return (
    <>
      <div className='h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-white'>
        <div className='max-w-md w-full space-y-8'>
          <div>
            <img className='mx-auto h-48 w-auto' src={logo} alt='Workflow' />
            <h2 className='mt-6 text-center text-3xl font-extrabold text-zinc-900'>
              Access Control
            </h2>
          </div>

          <form className='mt-8 space-y-6' onSubmit={handleSubmit}>
            <input type='hidden' name='remember' value='true' />

            <div className='shadow-sm -space-y-px'>
              <div>
                <label htmlFor='email-address' className='sr-only'>
                  Email
                </label>
                <input
                  id='email-address'
                  name='email'
                  type='email'
                  autoComplete='email'
                  required
                  className='relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 sm:text-sm'
                  placeholder='Email'
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div>
                <label htmlFor='password' className='sr-only'>
                  Contraseña
                </label>
                <input
                  id='password'
                  name='password'
                  type='password'
                  autoComplete='current-password'
                  required
                  className='relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 sm:text-sm'
                  placeholder='Contraseña'
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            {error.length > 0 && <p className='text-red-500 text-sm'> {error}</p>}

            <div>
              <button
                type='submit'
                className='group relative w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-medium rounded-sm text-white bg-gray-900 hover:bg-gray-800  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500'>
                <span className='absolute left-0 inset-y-0 flex items-center pl-3'>
                  <svg
                    className='h-5 w-5 text-white '
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 20 20'
                    fill='currentColor'
                    aria-hidden='true'>
                    <path
                      fillRule='evenodd'
                      d='M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z'
                      clipRule='evenodd'
                    />
                  </svg>
                </span>
                Acceder
                {loading && <Loader size='md' variant='dots' className='mx-2' color={"#F8F9FA"} />}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default Login
